import { VendorBanner } from '../../types/VendorDetail';

export const hasBannerData = (banner?: VendorBanner) => {
  if (!banner) return false;
  const values = Object.values(banner);

  return values.some(imageUrl => !!imageUrl);
};
